// extracted by mini-css-extract-plugin
module.exports = {"distribucion":"Primera_distribucion__2Sear","logo":"Primera_logo__348Kc","botonera":"Primera_botonera__GZ2By"};